import { render, staticRenderFns } from "./PostsPage.vue?vue&type=template&id=1a1e8811"
import script from "./PostsPage.vue?vue&type=script&lang=js"
export * from "./PostsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports